import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import { AI_LIMIT_EVENT, type AiLimitPayload } from './aiLimitEvents';

/** Mounted once in App: opens whenever any school AI feature is blocked (yada:ai-limit). */
export default function AiLimitDialog() {
  const navigate = useNavigate();
  const [payload, setPayload] = useState<AiLimitPayload | null>(null);

  useEffect(() => {
    const onLimit = (e: Event) => setPayload((e as CustomEvent<AiLimitPayload>).detail ?? null);
    window.addEventListener(AI_LIMIT_EVENT, onLimit);
    return () => window.removeEventListener(AI_LIMIT_EVENT, onLimit);
  }, []);

  const close = () => setPayload(null);
  const go = (hash: 'buy' | 'key') => { close(); navigate(`/settings/ai#${hash}`); };
  const canBuy = payload?.options?.buy_credit !== false;
  const title = payload?.limit_scope === 'user'
    ? "You've reached your monthly AI limit"
    : "Your school's AI credit has ended";

  return (
    <Modal
      isOpen={payload !== null}
      onClose={close}
      title={title}
      size="sm"
      footer={(
        <>
          <Button variant="ghost" onClick={close}>Not now</Button>
          <Button variant={canBuy ? 'ghost' : 'primary'} onClick={() => go('key')}>Add my OpenRouter key</Button>
          {canBuy && <Button variant="primary" onClick={() => go('buy')}>Buy credit</Button>}
        </>
      )}
    >
      <p className="text-sm text-ink">
        {payload?.detail ? `${payload.detail} ` : ''}
        You can keep using AI by buying your own credit or adding your own OpenRouter key.
      </p>
    </Modal>
  );
}
